import { getAppConfig } from "config/client.config";

export const FETCH_BLOG = "FETCH_BLOG";
export const INTER_ARTICLE = "INTER_ARTICLE";

const _fetchBlog = (status, data, err) => {
    return {
        type: FETCH_BLOG,
        data,
        err,
        status,
    };
};

const _interArticle = (status, data, err) => {
    return {
        type: INTER_ARTICLE,
        data,
        err,
        status,
    };
};

const fetchBlog = () => {
    return (dispatch, getState, Request) => {
        let blogPath = getAppConfig().endpoints.blogPath;
        dispatch(_fetchBlog("fetching", null, null));
        return Request.fetch(blogPath)
            .then((response) => {
                return response.json().then((data) => {
                    return dispatch(
                        _fetchBlog("success", { articles: data }, null)
                    );
                });
            })
            .catch((err) => {
                dispatch(_fetchBlog("error", null, err));
                return Promise.reject(err);
            });
    };
};
const fetchTags = () => {
    return (dispatch, getState, Request) => {
        let tagsPath = getAppConfig().endpoints.tagsPath;
        return Request.fetch(tagsPath)
            .then((response) => {
                return response.json().then((data) => {
                    return data;
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};

const fetchArticle = (articleId) => {
    return (dispatch, getState, Request) => {
        let getArticlePath = getAppConfig().endpoints.getArticlePath.replace(
            ":id",
            articleId
        );
        return Request.fetch(getArticlePath)
            .then((response) => {
                return response.json().then((data) => {
                    return Promise.resolve(data);
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};

const fetchArticleAdmin = (articleId) => {
    return (dispatch, getState, Request) => {
        let getArticlePath = getAppConfig()
            .endpoints.getArticlePath.replace(":id", articleId)
            .replace("show", "showAdmin");
        return Request.fetch(getArticlePath)
            .then((response) => {
                return response.json().then((data) => {
                    return Promise.resolve(data);
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};

const interArticle = (article) => {
    return (dispatch, getState, Request) => {
        return Promise.resolve(
            dispatch(_interArticle("success", { article: article }, null))
        );
    };
};

const createArticle = (articleHash) => {
    return (dispatch, getState, Request) => {
        let createArticlePath = getAppConfig().endpoints.createArticlePath;
        return Request.fetch(createArticlePath, {
            method: "POST",
            body: JSON.stringify(articleHash),
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                let blogPath = getAppConfig().endpoints.blogPath;
                return Request.fetch(blogPath)
                    .then((response) => {
                        return response.json().then((data) => {
                            return dispatch(
                                _fetchBlog("success", { articles: data }, null)
                            );
                        });
                    })
                    .catch((err) => {
                        dispatch(_fetchBlog("error", null, err));
                        return Promise.reject(err);
                    });
            })
            .catch((err) => {
                console.log(err);
            });
    };
};

const createTags = (tags) => {
    return (dispatch, getState, Request) => {
        let createTagsPath = getAppConfig().endpoints.createTagsPath;
        return Request.fetch(createTagsPath, {
            method: "POST",
            body: JSON.stringify({ tags: tags }),
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
            });
    };
};

const updateArticle = (articleId, articleHash) => {
    return (dispatch, getState, Request) => {
        let updateArticlePath = getAppConfig().endpoints.updateArticlePath.replace(
            ":id",
            articleId
        );
        return Request.fetch(updateArticlePath, {
            method: "POST",
            body: JSON.stringify(articleHash),
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                let blogPath = getAppConfig().endpoints.blogPath;
                return Request.fetch(blogPath)
                    .then((response) => {
                        return response.json().then((data) => {
                            return dispatch(
                                _fetchBlog("success", { articles: data }, null)
                            );
                        });
                    })
                    .catch((err) => {
                        dispatch(_fetchBlog("error", null, err));
                        return Promise.reject(err);
                    });
            })
            .catch((err) => {
                console.log(err);
            });
    };
};

const deleteArticle = (articleId) => {
    return (dispatch, getState, Request) => {
        let deleteArticlePath = getAppConfig().endpoints.deleteArticlePath.replace(
            ":id",
            articleId
        );
        return Request.fetch(deleteArticlePath, {
            method: "POST",
        })
            .then((response) => {
                let blogPath = getAppConfig().endpoints.blogPath;
                return Request.fetch(blogPath)
                    .then((response) => {
                        return response.json().then((data) => {
                            return dispatch(
                                _fetchBlog("success", { articles: data }, null)
                            );
                        });
                    })
                    .catch((err) => {
                        dispatch(_fetchBlog("error", null, err));
                        return Promise.reject(err);
                    });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};

const addComment = (articleId, comment) => {
    return (dispatch, getState, Request) => {
        let createArticleCommentPath = getAppConfig().endpoints.createArticleCommentPath.replace(
            ":id",
            articleId
        );
        return Request.fetch(createArticleCommentPath, {
            method: "POST",
            body: JSON.stringify({ comment: comment }),
        })
            .then((response) => {
                return response.json().then((data) => {
                    let blogPath = getAppConfig().endpoints.blogPath;
                    return Request.fetch(blogPath)
                        .then((response) => {
                            return response.json().then((data) => {
                                return dispatch(
                                    _fetchBlog(
                                        "success",
                                        { articles: data },
                                        null
                                    )
                                );
                            });
                        })
                        .catch((err) => {
                            dispatch(_fetchBlog("error", null, err));
                            return Promise.reject(err);
                        });
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};

const deleteComment = (articleId, commentId) => {
    return (dispatch, getState, Request) => {
        let deleteArticleCommentPath = getAppConfig()
            .endpoints.deleteArticleCommentPath.replace(":id", articleId)
            .replace(":comment_id", commentId);
        return Request.fetch(deleteArticleCommentPath, {
            method: "POST",
        })
            .then((response) => {
                return response.json().then((data) => {
                    let blogPath = getAppConfig().endpoints.blogPath;
                    return Request.fetch(blogPath)
                        .then((response) => {
                            return response.json().then((data) => {
                                return dispatch(
                                    _fetchBlog(
                                        "success",
                                        { articles: data },
                                        null
                                    )
                                );
                            });
                        })
                        .catch((err) => {
                            dispatch(_fetchBlog("error", null, err));
                            return Promise.reject(err);
                        });
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};

function fetchCourseSearch(query) {
    return (dispatch, getState, Request) => {
        return Request.fetch(getAppConfig().endpoints.contentPaths.searchCoursePath, {
            method: "POST",
            body: JSON.stringify({ query: query }),
        })
            .then((response) => {
                return response.json().then((data) => {
                    return Promise.resolve(data);
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
class BlogAction {
    static fetchBlog = fetchBlog;
    static fetchTags = fetchTags;
    static fetchArticle = fetchArticle;
    static fetchArticleAdmin = fetchArticleAdmin;
    static createArticle = createArticle;
    static interArticle = interArticle;
    static createTags = createTags;
    static updateArticle = updateArticle;
    static addComment = addComment;
    static deleteComment = deleteComment;
    static deleteArticle = deleteArticle;
    static fetchCourseSearch = fetchCourseSearch;
}

export default BlogAction;
